const LOGIN_TRADE_BYPASS_KEY = 'isFromLoginTrade';

export function setLoginTradeBypass() {
  sessionStorage.setItem(LOGIN_TRADE_BYPASS_KEY, 'true');
}

export function clearLoginTradeBypass() {
  sessionStorage.removeItem(LOGIN_TRADE_BYPASS_KEY);
}

export function hasLoginTradeBypass(userId) {
  if (!userId) {
    return false;
  }

  return sessionStorage.getItem(LOGIN_TRADE_BYPASS_KEY) === 'true';
}
